export default "__VITE_ASSET__BJO4jrk6__"